export default "__VITE_ASSET__DGty4upx__"